import {UP_FAILURE, UP_PENDING, UP_SUCCESS} from './constants'

const initialState = {
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UP_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case UP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        ...action.payload,
      }
    case UP_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
